import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PurchaseReturnReasonApi } from '../api/purchase-return-reason.api';
import { switchMap, map } from 'rxjs/operators';
import { PurchaseReturnReasonData, PurchaseReturnReason } from '../../../interfaces/masters/purchasereturnreason';

@Injectable({
  providedIn: 'root'
})
export class PurchaseReturnReasonService extends PurchaseReturnReasonData{

  constructor(private api: PurchaseReturnReasonApi) {
    super();
  }


  list(url: string): Observable<PurchaseReturnReason[]> {
    return this.api.list(url);
  }

  getById(url:string): Observable<PurchaseReturnReason>{
      return this.api.getById(url);
  }

  create(url: string, data:PurchaseReturnReason): Observable<PurchaseReturnReason[]> {
    return this.api.add(url,data);
  }

  update(url: string, data:PurchaseReturnReason): Observable<PurchaseReturnReason> {
    return this.api.update(url,data);
  }

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}

